import { useNavigate, useParams } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import { Box, Button, Tab, Tabs, Grid, Typography, CardMedia } from "@mui/material";
import React, { useEffect, useState } from "react";
import moment from "moment";
import RejectReasonModal from "../../Modals/rejectReason";
import TableComponent from "../../components/TableComponent";
import { useLazyGetUsersByIdQuery } from "../../services/customer";
import { showError } from "../../constants/toasts";
import { useLazyGetBookingQuery } from "../../services/booking";
import { Booking } from "../../types/General";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}


const venueColumns = [
  { field: "name", headerName: "Venue Name", flex: 1, minWidth: 150 },
  { field: "date", headerName: "Booking Date", flex: 1, minWidth: 150 },
  { field: "status", headerName: "Status", flex: 1, minWidth: 120 },
  { field: "amount", headerName: "Amount", flex: 1, minWidth: 100 },
];

const storageColumns = [
  { field: "name", headerName: "Storage Name", flex: 1, minWidth: 150 },
  { field: "date", headerName: "Booking Date", flex: 1, minWidth: 150 },
  { field: "status", headerName: "Status", flex: 1, minWidth: 120 },
  { field: "amount", headerName: "Amount", flex: 1, minWidth: 100 },
];

const ManageCustomerDetail = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
  const [valueTabs, setValueTabs] = React.useState(0);
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };
  const [open, setOpen] = useState(false);
  const handleCloseModal = () => {
    setOpen(false);
  };
  
  // Booking History sub-tabs
  const [bookingTab, setBookingTab] = useState(0);
  const handleBookingTabChange = (
    event: React.SyntheticEvent,
    newValue: number
  ) => {
    setBookingTab(newValue);
    setPage(1);
  };
  const [UserDetails] = useLazyGetUsersByIdQuery();
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState<any>(null);
  const [getBookingApi] = useLazyGetBookingQuery();
  const [count, setCount] = useState(10);
  const [page, setPage] = useState(1);
  const [bookingData, setBookingData] = useState<Booking[]>([]);
  const handlePageChange = (event: any, newPage: number) => {
    setPage(newPage);
  };

  const getDataByIdList = async () => {
    try {
      setLoading(true);
      if (!id) return;
      const response = await UserDetails({ id }).unwrap();
      if (response.statusCode === 200) {
        setUser(response.data);
      }
      setLoading(false);
    } catch (error: any) {
      setLoading(false);
      showError(error?.message || error?.data?.message);
    }
  };
  const getBookngApi = async () => {
    setLoading(true);
    try {
      const response = await getBookingApi({
        from: page,
        search: debouncedSearchTerm,
        size: 10,
        type: bookingTab === 0 ? "VENUE" : "STORAGE",
        userId: id as string,
        status: "",
      } as any).unwrap();
      setLoading(false);
      if (response.statusCode === 200) {
        setBookingData(response?.data?.data || []);
        setCount(response?.data?.total || 0);
      }
    } catch (error: any) {
      setLoading(false);
      showError(error?.data?.message || "");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (id) {
      getDataByIdList();
    }
  }, [id]);

  useEffect(() => {
    if (id) {
      getBookngApi();
    }
  }, [id, bookingTab, page, debouncedSearchTerm]);

  return (
    <>
      <MainContainer>
        <div className="main_title">
          <h1>User Detail</h1>
          <p>
            <span onClick={() => navigate("/dashboard")}>Dashboard</span> -{" "}
            <span onClick={() => navigate("/manage-customers")}>
              Manage User
            </span>{" "}
            - Customer Detail
          </p>
        </div>
        <div className="table_header">
          <div className="left_s">
            <Box className="custom_tabs1" sx={{ width: "100%" }}>
              <Tabs
                value={valueTabs}
                onChange={handleChangeTabs}
                aria-label="basic tabs example"
                className="custom_tabs_links"
              >
                <Tab label="General Details" {...a11yProps(0)} />
                <Tab label="Booking History" {...a11yProps(1)} />
              </Tabs>
            </Box>
          </div>
        </div>
        <CustomTabPanel value={valueTabs} index={0}>
          <div className="cards view_page">
            <div className="section_title">
              <h2>Personal Details</h2>
            </div>
            <div className="gap_p">
              <div className="vew_img w_100">
                <h6>Image</h6>
                <figure>
                  <img
                    alt="user"
                    src={
                      user?.profileImage ||
                      user?.image ||
                      "/static/images/user_placeholder.png"
                    }
                    onError={(e) => {
                      e.currentTarget.src =
                        "/static/images/user_placeholder.png";
                    }}
                  />
                </figure>
              </div>
              <div className="w_33">
                <h6>First Name</h6>
                <p>{user?.firstName || "N/A"}</p>
              </div>
              <div className="w_33">
                <h6>Middle Name</h6>
                <p>{user?.middleName || "N/A"}</p>
              </div>
              <div className="w_33">
                <h6>Date of Birth</h6>
                <p>{user?.dob ? moment(user.dob).format("DD MMM YYYY") : "N/A"}</p>
              </div>
              <div className="w_33">
                <h6>Last Name</h6>
                <p>{user?.lastName || "N/A"}</p>
              </div>
              <div className="w_33">
                <h6>Email Id</h6>
                <p>{user?.email || "N/A"}</p>
              </div>
              <div className="w_33">
                <h6>Phone Number</h6>
                <p>
                  {user?.countryCode && user?.phoneNumber
                    ? `${user.countryCode} ${user.phoneNumber}`
                    : "N/A"}
                </p>
              </div>
             
              <div className="w_33">
                <h6>Emergency Country Code</h6>
                <p>{user?.emergencyCountryCode || "N/A"}</p>
              </div>
              <div className="w_33">
                <h6>Emergency Calling Code</h6>
                <p>{user?.emergencyCallingCode || "N/A"}</p>
              </div>
              <div className="w_33">
                <h6>Emergency Contact Number</h6>
                <p>{user?.emergencyContactNumber || "N/A"}</p>
              </div>
              <div className="w_33">
                <h6>Address</h6>
                <p>
                  {user?.addressLineOne && user?.addressLineTwo
                    ? `${user.addressLineOne}, ${user.addressLineTwo}`
                    : user?.addressLineOne || user?.addressLineTwo || "N/A"}
                </p>
              </div>
              <div className="w_33">
                <h6>City</h6>
                <p>{user?.city || "N/A"}</p>
              </div>
              <div className="w_33">
                <h6>State</h6>
                <p>{user?.state || "N/A"}</p>
              </div>
              <div className="w_33">
                <h6>Country</h6>
                <p>{user?.country || "N/A"}</p>
              </div>
              <div className="w_33">
                <h6>Zip Code</h6>
                <p>{user?.zipCode || "N/A"}</p>
              </div>
            </div>
          </div>
          <div className="cards view_page">
            <div className="single_doc">
              <Grid container spacing={2}>
                <Grid item xs={12} className="heading">
                  <Typography className="document_head" variant="h5">
                    Document
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <div className="control_group">
                    <Typography className="custom_label">Document Image</Typography>
                    <Box className="docs_div v2">
                      <div className="upload_image no_radius v2">
                        <div className="upload_image_holder">
                          <figure>
                            <CardMedia
                              component="img"
                              image={
                                user?.documentImage || "/static/images/picture.png"
                              }
                              alt="Document"
                              style={{
                                maxWidth: "100%",
                                maxHeight: "300px",
                                objectFit: "contain",
                              }}
                              onError={(e) => {
                                e.currentTarget.src = "/static/images/picture.png";
                              }}
                            />
                          </figure>
                        </div>
                      </div>
                    </Box>
                  </div>
                </Grid>
              </Grid>
            </div>
          </div>
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={1}>
          <div className="cards">
            <Box className="custom_tabs1" sx={{ width: "100%" }}>
              <Tabs
                value={bookingTab}
                onChange={handleBookingTabChange}
                aria-label="booking history tabs"
                className="custom_tabs_links"
              >
                <Tab label="Venue" />
                <Tab label="Storage" />
              </Tabs>
            </Box>
            <CustomTabPanel value={bookingTab} index={0}>
              <div className="sorting_table">
                <TableComponent
                  columns={venueColumns}
                  rows={(bookingData || []).map((b: any) => ({
                    ...b,
                    name: b?.venueStorage?.name || "-",
                    date:
                      b?.from
                        ? moment(b?.from).isSame(b?.to, "day")
                          ? moment(b?.from).format("MMM DD")
                          : `${moment(b?.from).format("MMM DD")} - ${moment(
                              b?.to
                            ).format("MMM DD")}`
                        : "-",
                    status: b?.bookingStatus || "-",
                    amount: `$${b?.totalAmount || 0}`,
                  }))}
                  count={count}
                  page={page}
                  onPageChange={handlePageChange}
                  loading={loading}
                />
              </div>
            </CustomTabPanel>
            <CustomTabPanel value={bookingTab} index={1}>
              <div className="sorting_table">
                <TableComponent
                  columns={storageColumns}
                  rows={(bookingData || []).map((b: any) => ({
                    ...b,
                    name: b?.venueStorage?.name || "-",
                    date:
                      b?.from
                        ? moment(b?.from).isSame(b?.to, "day")
                          ? moment(b?.from).format("MMM DD")
                          : `${moment(b?.from).format("MMM DD")} - ${moment(
                              b?.to
                            ).format("MMM DD")}`
                        : "-",
                    status: b?.bookingStatus || "-",
                    amount: `$${b?.totalAmount || 0}`,
                  }))}
                  count={count}
                  page={page}
                  onPageChange={handlePageChange}
                  loading={loading}
                />
              </div>
            </CustomTabPanel>
          </div>
        </CustomTabPanel>
      </MainContainer>
      <RejectReasonModal
        open={open}
        onClose={handleCloseModal}
        setOpen={setOpen}
        onSubmit={() => {}}
      />
      
    </>
  );
};

export default ManageCustomerDetail;
